import { render, staticRenderFns } from "./DynamicVariablesPicker.vue?vue&type=template&id=5a84c485&scoped=true"
import script from "./DynamicVariablesPicker.vue?vue&type=script&lang=js"
export * from "./DynamicVariablesPicker.vue?vue&type=script&lang=js"
import style0 from "./DynamicVariablesPicker.vue?vue&type=style&index=0&id=5a84c485&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a84c485",
  null
  
)

export default component.exports